module.exports = __webpack_public_path__ + "templates.confirm-payment-type.modal-28fa0cd2.html";